import ReactDOM from "react-dom/client";
import App from "./App";
import "./index.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "./theme.css";
import { BrowserRouter as Router } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { SocketProvider } from "./Context/SocketContext";

const authCookie = localStorage.getItem("adminauthor");
const auth = authCookie ? JSON.parse(authCookie) : null;
const adminId = auth?.admin?._id;

ReactDOM.createRoot(document.getElementById("root")).render(
  <SocketProvider userId={adminId}>
    <Router>
      <ToastContainer />
      <App />
    </Router>
  </SocketProvider>
);
